'use client'

import { useEffect } from 'react'

import { useUserContext } from '@/context'
import { usePathname, useRouter } from '@/navigation'
import { useOnboardingGate } from '@/features/onboarding/useOnboardingGate'
import { isOnboardingEnabled } from '@/features/onboarding/onboarding.runtime'

const isTeamPath = (pathname: string | null | undefined): boolean =>
  pathname === '/team' || Boolean(pathname?.startsWith('/team/'))

export function PendingInvitationRedirect() {
  const { teams, isFetching, isLoadingUser } = useUserContext()
  const pathname = usePathname()
  const router = useRouter()
  const { gateResolved, isRequirementActive, isExiting } = useOnboardingGate()
  const onboardingEnabled = isOnboardingEnabled()

  const hasPendingInvitation = teams?.some((team) => team.status === 'PENDING')

  useEffect(() => {
    if (onboardingEnabled) return
    if (isFetching || isLoadingUser || !hasPendingInvitation) return
    if (!gateResolved || isRequirementActive || isExiting) return
    if (isTeamPath(pathname)) return

    router.replace('/team')
  }, [
    gateResolved,
    hasPendingInvitation,
    isExiting,
    isFetching,
    isLoadingUser,
    isRequirementActive,
    onboardingEnabled,
    pathname,
    router,
  ])

  return null
}
